module.exports = __webpack_public_path__ + "img/lock.c50ee791.png";